var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "CustomerLevelRuleList",
      "extra-items": _vm.isShow ? [{
        text: _vm.ruleBreadcrumbName
      }] : _vm.isEditing ? [{
        text: _vm.ruleBreadcrumbName,
        to: 'CustomerLevelRuleView',
        params: {
          id: _vm.customer_level_rule.id
        }
      }, '編輯會員等級條件'] : ['新增會員等級條件']
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('section', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v("基本設定")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "順序"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "0",
      "step": "1",
      "state": _vm.v$.customer_level_rule.order.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.customer_level_rule.order,
      callback: function callback($$v) {
        _vm.$set(_vm.customer_level_rule, "order", _vm._n($$v));
      },
      expression: "customer_level_rule.order"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.customer_level_rule.order.$error
    }
  }, [_vm._v(" 請輸入整數 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "類型",
      "label-for": "type"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "type",
      "options": _vm.customerLevelTypeOptions,
      "state": _vm.v$.customer_level_rule.type.$error ? false : null,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.customer_level_rule.type,
      callback: function callback($$v) {
        _vm.$set(_vm.customer_level_rule, "type", $$v);
      },
      expression: "customer_level_rule.type"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "原始等級",
      "label-for": "from-level"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "from-level",
      "options": _vm.customerLevelOptions.slice(0, ['upgrade', 'direct'].includes(_vm.customer_level_rule.type) ? -1 : _vm.customerLevelOptions.length),
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.customer_level_rule.from_customer_level_id,
      callback: function callback($$v) {
        _vm.$set(_vm.customer_level_rule, "from_customer_level_id", $$v);
      },
      expression: "customer_level_rule.from_customer_level_id"
    }
  }), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 選擇性設定：指定從哪個會員等級升級而來 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "目標等級",
      "label-for": "target-level"
    }
  }, [_c('b-form-select', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "target-level",
      "options": _vm.filteredTargetLevelOptions,
      "state": _vm.v$.customer_level_rule.customer_level_id.$error ? false : null,
      "disabled": _vm.isShow || !_vm.customer_level_rule.type || ['upgrade', 'keep'].includes(_vm.customer_level_rule.type)
    },
    model: {
      value: _vm.customer_level_rule.customer_level_id,
      callback: function callback($$v) {
        _vm.$set(_vm.customer_level_rule, "customer_level_id", $$v);
      },
      expression: "customer_level_rule.customer_level_id"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.customer_level_rule.customer_level_id.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.customer_level_rule.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.customer_level_rule, "is_enabled", $$v);
      },
      expression: "customer_level_rule.is_enabled"
    }
  })], 1), _vm.customer_level_rule.type === 'keep' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "續等時沿用原會籍起始日"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.rule.keep_original_start,
      callback: function callback($$v) {
        _vm.$set(_vm.rule, "keep_original_start", $$v);
      },
      expression: "rule.keep_original_start"
    }
  }, [_vm._v(" 是 ")]), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 續等過後，若要沿用原會籍期間之消費紀錄，則需啟用此項目 ")])], 1) : _vm._e()], 1)]), _c('section', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-12 col-xl-8"
  }, [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v("時間範圍")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "範圍類型"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.timeRangeTypeOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.rule.time_range.type,
      callback: function callback($$v) {
        _vm.$set(_vm.rule.time_range, "type", $$v);
      },
      expression: "rule.time_range.type"
    }
  })], 1), _vm.rule.time_range.type === 'custom_range' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "日期區間"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-input', {
    staticClass: "mr-2",
    attrs: {
      "type": "date",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.rule.time_range.start,
      callback: function callback($$v) {
        _vm.$set(_vm.rule.time_range, "start", $$v);
      },
      expression: "rule.time_range.start"
    }
  }), _c('span', {
    staticClass: "mx-2"
  }, [_vm._v("至")]), _c('b-form-input', {
    attrs: {
      "type": "date",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.rule.time_range.end,
      callback: function callback($$v) {
        _vm.$set(_vm.rule.time_range, "end", $$v);
      },
      expression: "rule.time_range.end"
    }
  })], 1)]) : _vm._e(), _vm.rule.time_range.type === 'rolling_days' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "天數"
    }
  }, [_c('b-input-group', {
    attrs: {
      "append": "天內"
    }
  }, [_c('b-form-input', {
    attrs: {
      "type": "number",
      "min": "1",
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.rule.time_range.days,
      callback: function callback($$v) {
        _vm.$set(_vm.rule.time_range, "days", _vm._n($$v));
      },
      expression: "rule.time_range.days"
    }
  })], 1), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v("計算過去 N 天內的資料")])], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "會籍起始日"
    }
  }, [_c('b-form-checkbox', {
    attrs: {
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.rule.use_membership_start_date,
      callback: function callback($$v) {
        _vm.$set(_vm.rule, "use_membership_start_date", $$v);
      },
      expression: "rule.use_membership_start_date"
    }
  }, [_vm._v(" 從會員等級起始時間開始計算 ")]), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" 勾選：取「會籍開始日」與「時間範圍開始日」較晚者"), _c('br'), _vm._v(" 不勾選：直接使用上方設定的時間範圍 ")])], 1)], 1)]), _c('section', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-12 col-xl-10"
  }, [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v("計算條件")]), _vm.rule.calculations.length > 1 ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "條件邏輯"
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": _vm.calculationLogicOptions,
      "disabled": _vm.isShow
    },
    model: {
      value: _vm.rule.calculation_logic,
      callback: function callback($$v) {
        _vm.$set(_vm.rule, "calculation_logic", $$v);
      },
      expression: "rule.calculation_logic"
    }
  }), _c('small', {
    staticClass: "form-text text-muted"
  }, [_vm._v(" AND：所有條件都要滿足 / OR：滿足任一條件即可 ")])], 1) : _vm._e(), _vm._l(_vm.rule.calculations, function (calc, index) {
    return _c('div', {
      key: index,
      staticClass: "card mb-3"
    }, [_c('div', {
      staticClass: "card-header d-flex justify-content-between align-items-center py-2"
    }, [_c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v("條件 " + _vm._s(index + 1))]), !_vm.isShow && _vm.rule.calculations.length > 1 ? _c('b-button', {
      attrs: {
        "variant": "outline-danger",
        "size": "sm"
      },
      on: {
        "click": function click($event) {
          return _vm.removeCalculation(index);
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()], 1), _c('div', {
      staticClass: "card-body"
    }, [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": "策略類型"
      }
    }, [_c('b-form-select', {
      attrs: {
        "options": _vm.strategyOptions,
        "disabled": _vm.isShow
      },
      on: {
        "change": function change($event) {
          return _vm.onStrategyChange(index);
        }
      },
      model: {
        value: calc.strategy,
        callback: function callback($$v) {
          _vm.$set(calc, "strategy", $$v);
        },
        expression: "calc.strategy"
      }
    })], 1), calc.strategy === 'order_sum' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": "累積金額"
      }
    }, [_c('b-input-group', {
      attrs: {
        "prepend": "NT$"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "disabled": _vm.isShow
      },
      on: {
        "blur": function blur($event) {
          return _vm.formatAmount(calc);
        }
      },
      model: {
        value: calc.amountFormatted,
        callback: function callback($$v) {
          _vm.$set(calc, "amountFormatted", $$v);
        },
        expression: "calc.amountFormatted"
      }
    })], 1)], 1)] : _vm._e(), calc.strategy === 'order_single_max' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": "單筆金額"
      }
    }, [_c('b-input-group', {
      attrs: {
        "prepend": "NT$"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "disabled": _vm.isShow
      },
      on: {
        "blur": function blur($event) {
          return _vm.formatAmount(calc);
        }
      },
      model: {
        value: calc.amountFormatted,
        callback: function callback($$v) {
          _vm.$set(calc, "amountFormatted", $$v);
        },
        expression: "calc.amountFormatted"
      }
    })], 1), _c('small', {
      staticClass: "form-text text-muted"
    }, [_vm._v("單筆訂單達到此金額即符合條件")])], 1)] : _vm._e(), calc.strategy === 'order_count' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": "消費次數"
      }
    }, [_c('b-input-group', {
      attrs: {
        "append": "次"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "1",
        "disabled": _vm.isShow
      },
      model: {
        value: calc.count,
        callback: function callback($$v) {
          _vm.$set(calc, "count", _vm._n($$v));
        },
        expression: "calc.count"
      }
    })], 1)], 1)] : _vm._e(), calc.strategy === 'order_count_min_amount' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": "消費次數"
      }
    }, [_c('b-input-group', {
      attrs: {
        "append": "次"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "1",
        "disabled": _vm.isShow
      },
      model: {
        value: calc.count,
        callback: function callback($$v) {
          _vm.$set(calc, "count", _vm._n($$v));
        },
        expression: "calc.count"
      }
    })], 1)], 1), _c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": "每次最低金額"
      }
    }, [_c('b-input-group', {
      attrs: {
        "prepend": "NT$"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "text",
        "disabled": _vm.isShow
      },
      on: {
        "blur": function blur($event) {
          return _vm.formatMinAmount(calc);
        }
      },
      model: {
        value: calc.minAmountFormatted,
        callback: function callback($$v) {
          _vm.$set(calc, "minAmountFormatted", $$v);
        },
        expression: "calc.minAmountFormatted"
      }
    })], 1), _c('small', {
      staticClass: "form-text text-muted"
    }, [_vm._v("每次消費須達到此金額才計入次數")])], 1)] : _vm._e(), calc.strategy === 'point_balance' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": "點數門檻"
      }
    }, [_c('b-input-group', {
      attrs: {
        "append": "點"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "0",
        "disabled": _vm.isShow
      },
      model: {
        value: calc.amount,
        callback: function callback($$v) {
          _vm.$set(calc, "amount", _vm._n($$v));
        },
        expression: "calc.amount"
      }
    })], 1)], 1)] : _vm._e(), calc.strategy === 'form_result_count' ? [_c('b-form-group', {
      attrs: {
        "label-cols": "12",
        "label-cols-lg": "2",
        "label-size": "sm",
        "label": "填寫次數"
      }
    }, [_c('b-input-group', {
      attrs: {
        "append": "次"
      }
    }, [_c('b-form-input', {
      attrs: {
        "type": "number",
        "min": "1",
        "disabled": _vm.isShow
      },
      model: {
        value: calc.count,
        callback: function callback($$v) {
          _vm.$set(calc, "count", _vm._n($$v));
        },
        expression: "calc.count"
      }
    })], 1)], 1)] : _vm._e()], 2)]);
  })], 2)])]), _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(" 返回 ")]), !_vm.isShow ? _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "show": _vm.isLoading && !_vm.isShow,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.isEditing ? "確認修改" : "確認新增") + " ")])], 1) : _vm._e()], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }